module.exports = __webpack_public_path__ + "img/bg-skills.471b01a1.svg";